import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { IonicModule } from '@ionic/angular';
import { TranslateModule } from '@ngx-translate/core';
import { CalendarModule } from 'ion7-calendar';

import { FilterModalComponent } from './filter-modal/filter-modal';
import { RegisterForTaskComponent } from './register-for-task/register-for-task.component';
import { MarkTaskDoneComponent } from './mark-task-done/mark-task-done.component';

@NgModule({
    declarations: [
        FilterModalComponent,
        RegisterForTaskComponent,
        MarkTaskDoneComponent
    ],
    imports: [
        CommonModule,
        FormsModule,
        IonicModule,
        TranslateModule,
        CalendarModule
    ],
    exports: [
        FilterModalComponent,
        RegisterForTaskComponent,
        MarkTaskDoneComponent
    ]
})
export class ComponentsModule {}
